module.exports = __webpack_public_path__ + "img/Image32.ceeb5fbd.jpg";